import { getFreeTrialPropertiesAsync } from './getFreeTrialPropertiesAsync'

export const getFreeTrialDurationAsync = async (refresh = false) => {
  const { durationDays } = await getFreeTrialPropertiesAsync(refresh)

  return durationDays
}
